import React from "react";
import { ResponsiveHeightContext } from "./ResponsiveHeightContextProvider";
import widgetConfig from "./widgetConfig";

interface WithResponsiveHeight {
  edit: boolean;
  widgetId: number;
  minUnitHeight: number;
}

// HOC responsible for updating the ResponsiveHeightContext with the current height of the wrapped components content.
// If in the editMode then always report the minUnitHeight.
const withResponsiveHeight = <P extends object>(BaseComponent: React.FC<P>) => (
  props: P & WithResponsiveHeight
) => {
  const { minUnitHeight, edit, widgetId } = props;
  const responsiveHeights = React.useContext(ResponsiveHeightContext);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const minPixelHeight =
    minUnitHeight * widgetConfig.rowHeight +
    (minUnitHeight - 1) * widgetConfig.margin;

  React.useEffect(() => {
    responsiveHeights.addWidget(
      widgetId.toString(),
      containerRef,
      minUnitHeight
    );
  }, [minUnitHeight]);

  if (edit) {
    return <BaseComponent {...props} />;
  }

  return (
    <div ref={containerRef} style={{ minHeight: `${minPixelHeight}px` }}>
      <BaseComponent {...props} />
    </div>
  );
};

export default withResponsiveHeight;
